import React from 'react';
import Button, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { LeftOutlined } from '@ant-design/icons';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { Tooltip } from 'antd';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?: any;
  onlyIcon?: boolean;
};

const PrevButton = ({
  comcode,
  custom,
  onlyIcon = false,
  ...otherProps
}: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    children: comcode??label,
    style,
  };

  if (props.to) {
    return (
      <Tooltip title='previous' color='#00a896'>
      <RouterLink
        component={Button}
        {...props}
        icon={<LeftOutlined style={{marginRight:'-5px',color:'primary'}}/> 
      }
      style={{
        width: onlyIcon?'30px': custom?.width ?? '60%',
        height:onlyIcon?'30px': custom?.height ?? 40,
        margin:'5px',
        borderRadius:'50%',
        padding:'5px',
      }}
      >
        {' '}
        {!onlyIcon ? props.children : null}
      </RouterLink>
      </Tooltip>
    );
  } else {
    return (
      <Button
        {...props}
        icon={<LeftOutlined />}
        style={{
          width: onlyIcon ? 33 : custom?.width ?? '20%',
          height: custom?.height ?? 40,
          margin: '5px',
          
        }}
      >
        {!onlyIcon ? props.children : null}
      </Button>
    );
  }
};

export default PrevButton;
